import axios from "axios"
import React, {
	useState,
	useEffect,
	useMemo,
	Fragment,
	useRef,
	useCallback,
} from "react"

import {
	FormControl,
	InputLabel,
	Input,
	FormHelperText,
	Alert,
} from "@mui/material"
import WebService from "../util/webService"
import { encodeParams, getAction } from "../util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import {
	Checkbox,
	FormGroup,
	FormControlLabel,
	Typography,
	Snackbar,
	TablePagination,
	TextField,
	withStyles,
	InputBase,
} from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "../components/FlatButton"
import useSnackbar from "../hooks/useSnackbar"
import MyTableHead from "../components/MyTableHead"
import useIndicator from "../hooks/useIndicator"
import Indicator from "../components/Indicator"
import MyDialog from "../components/MyDialog"
import useForm from "../hooks/useForm"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import Paper from "@mui/material/Paper"
import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
// date
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import "dayjs/locale/ko"
import { TimePicker } from "@mui/x-date-pickers/TimePicker"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"
import { searchSchool } from "../util/helper"

const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`

const RLTN_CODE = "S003"
const AttdncPage = () => {
	console.log("AttdncPage rendering...")
	const g_sel_code = "SA07"
	const g_stat_code = "SA08"
	const g_week_code = "SB07"

	const inputRef = useRef()
	const defUrl = "/lecture"
	const dateFormat = "YYYY-MM-DD HH:mm:ss"
	const [detailScreen, set_detailScreen] = useState(false)
	const [smstList, set_smstList] = useState([])
	const [selCodeList, set_selCodeList] = useState([])
	const [statCodeList, set_statCodeList] = useState([])
	const [weekCodeList, set_weekCodeList] = useState([])

	const fields = [
		{
			field: "id",
			placeholder: "아이디",
			type: "text",
			value: -1,
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "smstId",
			placeholder: "학교/년도/기수",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: smstList,
		},
		{
			field: "smstName",
			placeholder: "학교/년도/기수",
			type: "select",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "userId",
			placeholder: "강사명",
			type: "select",
			value: -1,
			visible: detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "teacherName",
			placeholder: "강사명",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "title",
			placeholder: "강좌 제목",
			type: "text",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "content",
			placeholder: "내용",
			type: "text",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "weekCode",
			placeholder: "요일",
			type: "checkbox",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: weekCodeList,
		},
		{
			field: "loc",
			placeholder: "위치",
			type: "text",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "rcrNum",
			placeholder: "모집인원",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "reqNum",
			placeholder: "신청인원",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "sttNum",
			placeholder: "수강인원",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "lfee",
			placeholder: "강의료",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "mfee",
			placeholder: "재료비",
			type: "number",
			value: "",
			visible: true,
			canSrch: false,
			selList: [],
		},
		{
			field: "selCode",
			placeholder: "선발방식",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: selCodeList,
		},
		{
			field: "selCodeName",
			placeholder: "선발방식",
			type: "select",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: selCodeList,
		},
		{
			field: "statCode",
			placeholder: "상태",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: statCodeList,
		},
		{
			field: "statCodeName",
			placeholder: "상태",
			type: "select",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "regTime",
			placeholder: "등록일시",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "uptTime",
			placeholder: "수정일시",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
	]
	// const [fields, set_fields] = useState([...defFields])

	const gdnFields = [
		{ field: "name", placeholder: "성명" },
		{ field: "loginId", placeholder: "ID" },
		{ field: "phone", placeholder: "전화번호" },
		{ field: "phoneCertYn", placeholder: "인증여부" },
	]

	const regiLectureFields = [
		{ field: "title", placeholder: "강좌제목", table: "lecture" },
		{
			field: "statCode",
			placeholder: "강좌상태",
			table: "lecture",
			fn: (code) => findCode("SA09", code),
		},
		{
			field: "statCode",
			placeholder: "신청상태",
			table: "regi",
			fn: (code) => findCode("SA12", code),
		},
		{
			field: "regCode",
			placeholder: "등록상태",
			table: "regi",
			fn: (code) => findCode("SB12", code),
		},
	]

	const visibleColumns = fields.filter((col) => col.visible)
	const defRecord = {}
	fields.forEach((d) => {
		defRecord[d.field] = d.value
	})

	const defTerms = {}
	fields
		.filter((col) => col.canSrch)
		.map((d) => d.field)
		.forEach((d) => (defTerms[d] = ""))
	const [record, set_record] = useState(defRecord)
	const [dataList, set_dataList] = useState([])

	const [skipPageReset, setSkipPageReset] = React.useState(false)
	const [openSnackbar, renderSnackbar] = useSnackbar()
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
	const dgHandler = useState(false)
	const [selIdx, set_selIdx] = useState(-1)
	const [pageNum, set_pageNum] = useState(0)
	const [pageSize, set_pageSize] = useState(10)
	const [totalCount, set_totalCount] = useState(0)
	const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
	const [terms, _set_terms] = useState(defTerms)
	const [fontSize, set_fontSize] = useState(12)
	const termsRef = useRef(terms)
	const [smstGroup, set_smstGroup] = useState([])
	// redux
	const codeGroups = useSelector((state) => state.codeGroupReducer)
	const codes = useSelector((state) => state.codeReducer)
	const schools = useSelector((state) => state.schoolReducer)

	const defLschList = useMemo(() => {
		const lschList = []
		const lsch = {
			id: -1,
			lectureId: -1,
			weekCode: "-1",
			startTime: null,
			endTime: null,
		}

		codes
			.filter((c) => c.codeGroupId === g_week_code)
			.forEach((w) => {
				lschList.push({ ...lsch, weekCode: w.code })
			})

		return lschList
	})

	const ltgList = useMemo(() => {
		const ltgList = []
		const ltg = {
			id: -1,
			lectureId: -1,
			grade: -1,
		}
		for (let i = 1; i < 7; i++) {
			ltgList.push({ ...ltg, grade: i })
		}
		return ltgList
	})

	const set_terms = (data) => {
		termsRef.current = data
		_set_terms(data)
	}

	const onLoad = async () => {
		openIndicator()
		let url = `${defUrl}/extra`
		const newTerms = {}
		Object.keys(termsRef.current).forEach((key) => {
			if (termsRef.current[key] !== "") {
				newTerms[key] = termsRef.current[key]
			}
		})

		let tempList
		let resp = await WebService.get(url, {
			pageNum: pageInfo.pageNum,
			pageSize: pageInfo.pageSize,
			terms: JSON.stringify(newTerms),
		})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const originList = JSON.parse(repMessage.records)
			const totalCount = repMessage.totalCount

			set_totalCount(totalCount)
			const records = originList.reduce((acc, cur, idx, arr) => {
				const lecture = cur.lecture
				lecture.teacherName = arr[idx].teacher.name
				lecture.userId = arr[idx].teacher.id
				acc.push(lecture)
				return acc
			}, [])

			records.forEach((r) => {
				r.isDetail = false
				r.weekCodeList = []
				r.lschList = defLschList
				r.ltgList = []
			})

			// set_dataList(records)
			tempList = records
		}

		tempList.forEach((temp) => {
			const found = schools.find((d) => d.id === temp.schoolId)
			if (found) {
				temp.schoolId = found.id
				temp.schoolName = found.name
			}
		})

		// 학기
		url = "/smst"
		resp = await WebService.get(url, {})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.forEach((r) => {
				const school = schools.find((s) => s.id === +r.schoolId)
				if (school) {
					r.name = `${school.name}/${r.year}/${r.gisu}`
				} else {
				}
			})
			records.unshift({ id: -1, name: "학교 기수 선택" })
			set_smstList(records)

			tempList.forEach((temp) => {
				const found = records.find((d) => d.id === temp.smstId)
				if (found) {
					temp.smstName = found.name
				}
			})
		}

		// 코드
		let records
		records = codes.filter((c) => c.codeGroupId === g_sel_code)
		records.forEach((r) => {
			r.id = r.code
		})
		records.unshift({ id: -1, name: "선발방식 선택" })
		set_selCodeList(records)
		tempList.forEach((temp) => {
			const found = records.find((d) => d.id === temp.selCode)
			if (found) {
				temp.selCodeName = found.name
			}
		})

		records = codes.filter((c) => c.codeGroupId === g_stat_code)
		records.forEach((r) => {
			r.id = r.code
		})
		records.unshift({ id: -1, name: "상태 선택" })
		set_statCodeList(records)
		tempList.forEach((temp) => {
			const found = records.find((d) => d.id === temp.statCode)
			if (found) {
				temp.statCodeName = found.name
			}
		})

		records = codes.filter((c) => c.codeGroupId === g_week_code)
		records.forEach((r) => {
			r.id = r.code
		})

		set_weekCodeList(records)

		// teacher list
		// url = '/user/school'
		// resp = await WebService.get(url, {rltnCode: RLTN_CODE})
		// if(resp.repCode === 'ack') {
		//   const repMessage = JSON.parse(resp.repMessage)
		//   const records = JSON.parse(repMessage.records)
		//   records.unshift({id:-1, name: '강사 선택'})
		//   set_teacherList(records)

		//   tempList.forEach(st => {
		//     const found = records.find(d => d.id === st.userId)
		//     if(found) {
		//       st.teacherName = found.name
		//     }
		//   })
		// }

		const smstGroup = tempList.reduce((acc, cur) => {
			if (acc[cur.smstId]) {
				acc[cur.smstId].push(cur)
			} else {
				acc[cur.smstId] = [cur]
			}
			return acc
		}, {})
		set_dataList(smstGroup)
		closeIndicator()
	}

	const onDetail = async (lectureId) => {
		set_detailScreen(true)
		dgHandler[1](true)
	}

	const onDelete = async (id) => {
		const url = defUrl
		const resp = await WebService.delete(url, { id: id })
		if (resp.repCode === "ack") {
			onLoad()
			openSnackbar("삭제되었습니다.")
		} else {
			openSnackbar(resp.repMessage)
		}
	}

	const onCreate = () => {
		const now = moment().format(dateFormat)
		const newRecord = { ...defRecord, regTime: now, uptTime: now }
		newRecord.weekCodeList = []
		newRecord.lschList = defLschList
		newRecord.ltgList = []

		set_record(newRecord)
		set_detailScreen(true)
		dgHandler[1](true)
	}

	const onSearch = () => {
		onLoad()
	}

	const onClear = () => {
		const obj = {}
		Object.keys(terms).forEach((k) => {
			obj[k] = ""
		})
		set_terms(obj)
	}

	const handleChangePage = (event, newPage) => {
		set_pageInfo({ ...pageInfo, pageNum: newPage })
	}

	const handleChangeRowsPerPage = (event) => {
		const pageSize = parseInt(event.target.value, 10)
		set_pageInfo({ pageNum: 0, pageSize: pageSize })
	}

	const TablePaginationActions = (props) => {
		const theme = useTheme()
		const { count, page, rowsPerPage, onPageChange } = props

		const handleFirstPageButtonClick = (event) => {
			onPageChange(event, 0)
		}

		const handleBackButtonClick = (event) => {
			onPageChange(event, page - 1)
		}

		const handleNextButtonClick = (event) => {
			onPageChange(event, page + 1)
		}

		const handleLastPageButtonClick = (event) => {
			onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
		}

		return (
			<Box sx={{ flexShrink: 0, ml: 2.5 }}>
				<IconButton
					onClick={handleFirstPageButtonClick}
					disabled={page === 0}
					aria-label='first page'>
					{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
				</IconButton>
				<IconButton
					onClick={handleBackButtonClick}
					disabled={page === 0}
					aria-label='previous page'>
					{theme.direction === "rtl" ? (
						<KeyboardArrowRight />
					) : (
						<KeyboardArrowLeft />
					)}
				</IconButton>
				<IconButton
					onClick={handleNextButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label='next page'>
					{theme.direction === "rtl" ? (
						<KeyboardArrowLeft />
					) : (
						<KeyboardArrowRight />
					)}
				</IconButton>
				<IconButton
					onClick={handleLastPageButtonClick}
					disabled={page >= Math.ceil(count / rowsPerPage) - 1}
					aria-label='last page'>
					{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
				</IconButton>
			</Box>
		)
	}

	const findCode = (codeGroupId, code) => {
		const found = codes
			.filter((d) => d.codeGroupId === codeGroupId)
			.find((d) => d.code === code)
		return found
	}

	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: "center",
		color: theme.palette.text.secondary,
	}))

	const DgContent = () => {
		const xs = 12 / visibleColumns.length <= 3 ? 3 : 12 / visibleColumns.length

		const onSubmit = async () => {
			if (activeRow.weekCodeList.length === 0) {
				openSnackbar("한 개 이상의 요일이 선택되어야 합니다.")
				return
			}
			var flag = true
			activeRow.weekCodeList.forEach((w) => {
				const found = activeRow.lschList.find(
					(lsch) => lsch.weekCode === w.code
				)
				if (found) {
					if (found.startTime === null || found.endTime === null) {
						flag = false
						return false
					}
					// TODO
					// 시간 전후 체크
				}
			})
			if (!flag) {
				openSnackbar("체크된 요일은 시작시간과 입력시간을 입력해야 합니다.")
				return
			}

			if (activeRow.ltgList.length === 0) {
				openSnackbar("한 개 이상의 학년을 체크해 주세요.")
				return
			}

			const temp = activeRow.lschList.filter(
				(lsch) => lsch.startTime !== null || lsch.endTime !== null
			)
			const datum1 = JSON.parse(JSON.stringify(temp))
			datum1.forEach((lsch) => {
				lsch.lectureId = activeRow.id
				lsch.startTime = moment(new Date(lsch.startTime)).format("HH:mm")
				lsch.endTime = moment(new Date(lsch.endTime)).format("HH:mm")
			})

			const datum2 = activeRow.ltgList
			datum2.forEach((ltg) => {
				ltg.lectureId = activeRow.id
			})

			const data = {
				lecture: JSON.stringify(activeRow),
				lschList: JSON.stringify(datum1),
				ltgList: JSON.stringify(datum2),
			}

			const url = `${defUrl}/lsch/ltg`
			const resp = await WebService.post(url, data)
			if (resp.repCode === "ack") {
				onLoad()
				handleChange()
				openSnackbar("저장되었습니다.")
			} else {
				openSnackbar("에러 발생")
			}

		}

		const onChangeWeek = async (weekCode, e) => {
			const week = weekCodeList.find((d) => d.id === weekCode)
			const found = activeRow.weekCodeList.find((d) => d.id === weekCode)
			if (found && !e.target.checked) {
				const idx = activeRow.weekCodeList.indexOf(found)
				activeRow.weekCodeList.splice(idx, 1)
				const lsch = activeRow.lschList.find(
					(lsch) => lsch.weekCode === weekCode
				)
				lsch.startTime = null
				lsch.endTime = null

				handleChange()
			}
			if (!found && e.target.checked) {
				activeRow.weekCodeList.push(week)
				handleChange()
			}
		}

		const onChangeGrade = async (grade, e) => {
			const ltg = ltgList.find((d) => d.grade === grade)
			const found = activeRow.ltgList.find((d) => d.grade === grade)
			if (found && !e.target.checked) {
				const idx = activeRow.ltgList.indexOf(found)
				activeRow.ltgList.splice(idx, 1)
				handleChange()
			}
			if (!found && e.target.checked) {
				activeRow.ltgList.push(ltg)
				handleChange()
			}
		}

		const validate = () => {}
		const [activeRow, errors, formLoading, handleChange, handleSubmit] =
			useForm({
				initialValues: { ...record },
				onSubmit: onSubmit,
				validate: validate,
			})

		const [emailError, setEmailError] = useState("")
		const [passwordState, setPasswordState] = useState("")
		const [passwordError, setPasswordError] = useState("")
		const [nameError, setNameError] = useState("")
		const [registerError, setRegisterError] = useState("")
		const [teacherList, _set_teacherList] = useState([])
		const [attdncList, _set_attdncList] = useState({})
		const [lschList, _set_lschList] = useState([])
		const [cursor, set_cursor] = useState(0)
		// const Boxs = styled(Box)`
		//   padding-bottom: 40px !important;
		// `;

		const statCodes = codes.filter((c) => c.codeGroupId === "SA10")

		const set_lschList = async (lectureId) => {
			let url
			let resp

			url = `/lsch/lecture/${lectureId}`
			resp = await WebService.get(url, {})
			if (resp.repCode === "ack") {
				const repMessage = JSON.parse(resp.repMessage)
				const records = JSON.parse(repMessage.records)
				_set_lschList(records)
			}
		}

		const set_attdncList = async (lectureId) => {
			let url
			let resp

			url = `/attdnc/lecture/${lectureId}`
			resp = await WebService.get(url, {})
			if (resp.repCode === "ack") {
				const repMessage = JSON.parse(resp.repMessage)
				const originList = JSON.parse(repMessage.records)

				const attdncGroup = originList.reduce((acc, cur) => {
					if (acc[cur.attdnc.id]) {
						acc[cur.attdnc.id].push(cur)
					} else {
						// cur.rowSpan = 2
						acc[cur.attdnc.id] = [cur]
					}

					return acc
				}, {})
				_set_attdncList(attdncGroup)

				const firstKey = Object.keys(attdncGroup)[0]
				const data = attdncGroup[firstKey]
			}
		}

		const setUp = async (lectureId) => {
			await set_lschList(lectureId)
			await set_attdncList(lectureId)
		}

		const prevCursor = () => {
			if (cursor > 0) {
				const new_cursor = cursor - 1
				set_cursor(new_cursor)
			}
		}

		const nextCursor = () => {
			const keyLength = Object.keys(attdncList).length
			if (cursor < keyLength - 1) {
				const new_cursor = cursor + 1
				set_cursor(new_cursor)
			}
		}

		const onChangeBing = async (attdncId, index, e) => {
			const url = "/attdnc/bing"
			const new_attdncList = { ...attdncList }
			new_attdncList[attdncId][index].bing.statCode = e.target.value
			const bing = new_attdncList[attdncId][index].bing

			const resp = await WebService.post(url, bing)
			if (resp.repCode === "ack") {
				_set_teacherList(new_attdncList)
				openSnackbar(`출석상태가 변경되었습니다(id:${bing.id}).`)
			} else {
				openSnackbar(resp.repMessage)
			}
		}

		useEffect(() => {
			setUp(activeRow.id)
		}, [])

		const label = { inputProps: { "aria-label": "Checkbox demo" } }

		return (
			<Container component='main' maxWidth='lg'>
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
					}}>
					<Typography component='h1' variant='h5' sx={{ mt: 2 }}>
						출석부
					</Typography>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							{
								Object.keys(attdncList).map((key, index) => {
									if (index === cursor) {
										return (
											<div>
												<div>
													<Button onClick={prevCursor}>Prev</Button>
												</div>
												<div>
													{moment(
														attdncList[key][0].attdnc.lectureTime,
														"YYYY-MM-DD HH:mm:ss"
													).format("YYYY-MM-DD")}
												</div>
												<div>
													<Button onClick={nextCursor}>Next</Button>
												</div>
												{attdncList[key].map((data, index2) => {
													return (
														<Fragment>
															<div>{data.student.name}</div>
															<FormControl fullWidth>
																<Select
																	required
																	value={data.bing.statCode}
																	size='small'
																	onChange={(e) => {
																		onChangeBing(key, index2, e)
																		// const new_attdncList = {...attdncList}
																		// new_attdncList[key][index2].bing.statCode = e.target.value
																		// _set_attdncList(new_attdncList)
																	}}>
																	{statCodes.map((code) => {
																		return (
																			<MenuItem value={code.code}>
																				{code.name}
																			</MenuItem>
																		)
																	})}
																</Select>
															</FormControl>
														</Fragment>
													)
												})}
											</div>
										)
									}
								})

								// attdncList[16].map(data => {
								//   return(
								//     <Fragment>
								//       <div>{data.attdnc.lectureTime}</div>
								//       <div>{data.student.name}</div>
								//     </Fragment>
								//   )
								// })
							}
						</Grid>
					</Grid>
					<Button
						variant='contained'
						color='primary'
						size='small'
						onClick={onSubmit}
						sx={{ mt: 1, width: 100 }}>
						저장
					</Button>
				</Box>
			</Container>
		)
	}

	useEffect(() => {
		onLoad()
	}, [pageInfo])

	useEffect(() => {
		const size = window
			.getComputedStyle(inputRef.current, null)
			.getPropertyValue("font-size")

		set_fontSize(size)
	}, [])

	const dg_title = "출석부 정보"
	const memo_DgContent = useMemo(() => {
		return <DgContent />
	}, [record, detailScreen])
	if (dataList != null) {
		return (
			<div ref={inputRef}>
				<MyDialog
					title={dg_title}
					component={memo_DgContent}
					dialogHandler={dgHandler}
					callback={() => {
						set_detailScreen(false)
					}}
				/>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
					}}>
					<div style={{ paddingRight: 10 }}>
						<h1>출석부 관리 </h1>
					</div>
					<div>
						<Button
							variant='contained'
							color='primary'
							size='small'
							onClick={() => {
								onCreate()
							}}>
							생성
						</Button>
					</div>
				</div>

				<div style={{ paddingTop: 20 }}>
					<MUITable>
						<MyTableHead>
							<TableRow>
								{fields.map((col, index2) => {
									if (col.visible) {
										return (
											<TableCell key={index2} size='small' key={col.field}>
												{col.placeholder}
												{col.canSrch ? (
													<Fragment>
														<br />
														<TextField
															label=''
															variant='outlined'
															size='small'
															inputProps={{
																style: {
																	fontSize: "0.875em",
																	padding: 5,
																	backgroundColor: "#fff",
																},
															}}
															value={terms[col.field]}
															onChange={(e) => {
																const newTerms = { ...terms }
																newTerms[col.field] = e.target.value
																set_terms(newTerms)
															}}
														/>
													</Fragment>
												) : (
													<Fragment>
														<br />
														<br />
													</Fragment>
												)}
											</TableCell>
										)
									}
								})}
								<TableCell size='small'>
									<br />
									<FlatButton
										size='small'
										variant='contained'
										style={{ marginRight: 5 }}
										color='primary'
										onClick={onSearch}>
										검색
									</FlatButton>
									<FlatButton
										size='small'
										variant='contained'
										color='primary'
										onClick={onClear}>
										지우기
									</FlatButton>
								</TableCell>
							</TableRow>
						</MyTableHead>
						<TableBody>
							{Object.keys(dataList).map((smstId) => {
								return (
									<Fragment>
										<TableRow>
											<TableCell rowSpan={dataList[smstId].length + 1}>
												{dataList[smstId].length > 0
													? dataList[smstId][0].smstName
													: "데이터 없음"}
											</TableCell>
										</TableRow>
										{dataList[smstId].map((row, index) => {
											return (
												<TableRow
													onClick={() => {
														set_selIdx(index)
														set_record(row)
													}}>
													{fields.map((col, index2) => {
														if (col.visible && col.field !== "smstName") {
															return (
																<TableCell key={index2} size='small'>
																	{row[col.field]}
																</TableCell>
															)
														}
													})}
													<TableCell size='small'>
														<FlatButton
															variant='outlined'
															size='small'
															style={{ marginRight: 5 }}
															onClick={() => onDetail(row.id)}>
															보기
														</FlatButton>
														<FlatButton
															variant='outlined'
															color='error'
															size='small'
															onClick={() => onDelete(row.id)}>
															삭제
														</FlatButton>
													</TableCell>
												</TableRow>
											)
										})}
									</Fragment>
								)
							})}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TablePagination
									rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
									colSpan={visibleColumns.length + 1}
									count={totalCount}
									rowsPerPage={pageInfo.pageSize}
									page={pageInfo.pageNum}
									SelectProps={{
										inputProps: {
											"aria-label": "rows per page",
										},
										native: true,
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={TablePaginationActions}
									labelDisplayedRows={({ from, to, count }) => {
										// return '' + from + '-' + to + ' 개 ' + count
										return `${from} - ${to} of ${count}`
									}}
									labelRowsPerPage={"페이지당 갯수"}
								/>
							</TableRow>
						</TableFooter>
					</MUITable>

					{renderSnackbar()}
					{renderIndicator()}
					<dg_content />
				</div>
			</div>
		)
	}
}

export default AttdncPage
